const Input = ({ input_box, label_name, label_class, input_type, onChange, input_name, value, input_class, placeholder }) => {
    return (
        <div className={input_box}>
            <label className={`block text-sm xsm:text-base leading-5 font-medium ${label_class}`}>{label_name}</label>
            <input type={input_type} name={input_name} value={value} onChange={onChange} placeholder={placeholder} className={`block !rounded-none text-sm leading-5 font-normal text-[#8D8D8D] w-full border-b border-[#8D8D8D] focus-visible:outline-none py-1.5 xsm:py-2.5 ${input_class}`} />
        </div>
    )
}

export default Input;